import NiceModal from "@ebay/nice-modal-react";
import CustomButton from "components/buttons/CustomButton";
import P from "components/P";

import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import ModalBase from "modals/base/ModalBase";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// BiometricGuideModal.js
const BiometricGuideModal = NiceModal.create(props => {
    const [step, setStep] = useState(1);
    const modal = useRef();
    const { t } = useTranslation();
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["90%", "40%"];
    const clickOutsideToClose = false;
    const title = t("");
    const buttonText = t("close");


    const renderStep = () => {
        switch (step) {
            case 1:
                return (
                    <VerticalFlex>
                        <FlexChild>
                            <Center>
                                
                                <P size={20} weight={700}>생체인증 등록하기</P>
                                <P>빠르고 안전한 로그인을 위해 </P>
                                <P>생체인증을 설정해보세요</P>
                            </Center>
                        </FlexChild>

                        <FlexChild>
                            <HorizontalFlex gap={10}>
                                <FlexChild justifyContent="flex-end">
                                    <CustomButton style={{ backgroundColor: "var(--main-color)", color: "#fff", fontWeight: 700, border: "none" }} text="시작하기" onClick={
                                        () => {
                                            modal.current.close();
                                            props.onContinue && props.onContinue();
                                        }
                                    } />
                                </FlexChild>
                                <FlexChild justifyContent="flex-start">
                                    <CustomButton text="나중에 하기" style={{ backgroundColor: "#f5f5f5", color: "#666", fontWeight: 700, border: "none" }}
                                        onClick={() => {
                                            modal.current.close();
                                            props.onSkip && props.onSkip();
                                        }} />
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>

                    </VerticalFlex>
                );
        }
    };

    return (
        <ModalBase
            ref={modal}
            width={width}
            height={height}
            onClose={props.onClose}
            withHeader={withHeader}
            withFooter={withFooter}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            overflow={"visible"}
            borderRadius={"25px"}
        >
            {renderStep()}
        </ModalBase>
    );
});

export default BiometricGuideModal;